// api should be here
import { http } from '@/utils/http';
import qs from 'qs';
// 活动api baseurl
const urlPrefix = 'vote/2024project/q1/2024ygxq/controller.php?enews=';

const getBaseInfo = () => {
  return http.get(`${urlPrefix}base-info`);
};

// 提交
const save = (data: any) => {
  const qsData = qs.stringify(data);
  return http.post(`${urlPrefix}saveMessage`, qsData, { headers: {} });
};

const getCompanyList = (page:number,currentId:number) => {
  return http.get(`${urlPrefix}getCompanyList&page=${page}&addrTypes=${currentId}`);
};

const getOnlineList = (page:number) => {
  return http.get(`${urlPrefix}getOnlineList&page=${page}`);
};


const getNews = (page: any, category: any, classId: any) => {
  return http.get(
    `/v1/news/topicList?page=${page}&classId=${classId}&category=${category}`,
  );
};

export { getBaseInfo,save,getCompanyList,getOnlineList,getNews };
